// extracted by mini-css-extract-plugin
module.exports = {"container":"Carousel_style_container__2mCKj","arrow":"Carousel_style_arrow__1c6xg","right":"Carousel_style_right__1_CEW","left":"Carousel_style_left__23jK6"};